// src/stores/useOperatingAoiContext.js
//
// No persistence — every session starts with activeOperatingAoiId=null
// (the open state). The operator picks a workbench explicitly via the
// TopNav picker; the yellow nudge in PanelHeader prompts them.
//
// setOperatingAois only sets the list — it does NOT auto-pick a default
// (used to pick is_default || aois[0]; removed so the open state holds
// until the user acts). scopeMode tracks activeOperatingAoiId and is
// maintained by setActiveOperatingAoiId.

import { create } from "zustand";

export const useOperatingAoiContext = create((set) => ({
  // ---- State ----
  scopeMode: "org", // "org" | "operating_aoi"
  activeOperatingAoiId: null,
  operatingAois: [],
  loading: false,

  // ---- Actions ----
  setOperatingAois: (aois) =>
    set(() => ({
      operatingAois: Array.isArray(aois) ? aois : [],
    })),

  setActiveOperatingAoiId: (id) =>
    set(() => ({
      activeOperatingAoiId: id,
      scopeMode: id ? "operating_aoi" : "org",
    })),

  clearOperatingAoi: () =>
    set(() => ({
      scopeMode: "org",
      activeOperatingAoiId: null,
    })),
}));